<ng-container *ngIf="loading">
	<div class="container-with-loading">
		<div class="loading-overlay">
			<mat-spinner></mat-spinner>
		</div>
	</div>
  </ng-container>
  
  <mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
      <mat-card-title> <mat-icon matListIcon>edit_note</mat-icon>Grupos Firmas</mat-card-title>

		<div class="control"> 
			<button mat-flat-button class="button buttonWidth" type="button" (click)="addNewSignaturesGroup()">
				Crear Grupo
			</button>
		</div>

    </mat-card-header-->
    <mat-card-content>

	<div id="container">
		<!--div id="title"><h2>Firmas</h2></div-->
		<br>
		<div id="fieldsContainer">
			<mat-accordion class="iconTitle" multi>
				<mat-expansion-panel #advancedPanel>
					<mat-expansion-panel-header>
						<mat-panel-title>
							<mat-icon>find_in_page</mat-icon>B&uacute;squeda Avanzada
						</mat-panel-title>
					</mat-expansion-panel-header>
					<div id="container" class="formControl">
						<div class="control">
							<mat-form-field class="imput-full-width">
							<mat-label>Descripción</mat-label>
							<input type="text" matInput name="filterHolidays.description" [(ngModel)]="filterSignature.description">
							</mat-form-field>
						</div>
						
					</div>
					<div id="buttonContainer">
						<button mat-flat-button class="button" (click)="searchSignaturePaginatorAS()">
							<mat-icon>search</mat-icon>Consultar
						</button>
					</div>
				</mat-expansion-panel>
			</mat-accordion>
		</div>
		<br>
		<div id="tableContainer">
			<app-table #signaturesTable
				(paginatorEvent)="paginatorEvent($event)"
				(editEvent)="editEvent($event)"	
				[tableModel]="tableModel">
			</app-table>
		</div>
		<br>
	</div>

    </mat-card-content>
<mat-card-footer class="general-wf-card-footer">
</mat-card-footer>
</mat-card>